import { defineComponent as _defineComponent } from 'vue'
import { AmountType, DrawdownQuotePriceResponse } from 'ah-api-gateways';
import TradesFormattedCurrency from '../../currency/TradesFormattedCurrency.vue';
import { TradeDetails } from 'src/models/trade';
import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CostTransparencyDetailsInfo',
  props: {
  tradeDetails: {
    type: Object as PropType<TradeDetails>,
    required: true,
  },
  tradePrice: {
    type: Object as PropType<DrawdownQuotePriceResponse | null>,
    required: false,
  },
  costTransparencyCurrency: {
    type: String as PropType<AmountType>,
    required: true,
  },
},
  emits: ["update:costTransparencyCurrency"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:costTransparencyCurrency', value: AmountType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const showProtectionInSell = computed(() => {
  return props.costTransparencyCurrency === AmountType.SELL;
});

const currency = computed(() => {
  return showProtectionInSell.value ? props.tradeDetails.sellCurrency : props.tradeDetails.buyCurrency;
});

function changePremiumCurrency(amountType: AmountType) {
  emit('update:costTransparencyCurrency', amountType);
}

const costCCY = computed(() =>
  props.tradePrice?.ccy1.amountType === props.costTransparencyCurrency ? props.tradePrice?.ccy1 : props.tradePrice?.ccy2
);

const bpFormatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

// FIXME remove the formatter when the API sends clientCostBasisPoints with 2 decimal places instead of four
const basisPointsAmount = computed(() =>
  costCCY.value?.clientCostBasisPoints ? bpFormatter.format(costCCY.value.clientCostBasisPoints) : '0'
);

const basisPointsAmountPercentage = computed(() =>
  costCCY.value?.clientCostBasisPoints ? bpFormatter.format(costCCY.value.clientCostBasisPoints / 100) : '0'
);

return { __sfc: true,props, emit, showProtectionInSell, currency, changePremiumCurrency, costCCY, bpFormatter, basisPointsAmount, basisPointsAmountPercentage, AmountType, TradesFormattedCurrency }
}

})